import { WORKSPACE_EXPORT_STATUS } from '@/constants/workspaceData';

export type WorkspaceExportStatus =
  (typeof WORKSPACE_EXPORT_STATUS)[keyof typeof WORKSPACE_EXPORT_STATUS];

export interface WorkspaceExportApiResource {
  id: string;
  status: WorkspaceExportStatus;
  created_at: string;
  completed_at: string | null;
  expires_at: string | null;
}

export interface WorkspaceExportDownloadApiResource {
  download_url: string;
}

export interface WorkspaceExport {
  id: string;
  status: WorkspaceExportStatus;
  createdAt: string;
  completedAt: string | null;
  expiresAt: string | null;
}

export function mapApiResourceToWorkspaceExport(
  resource: WorkspaceExportApiResource
): WorkspaceExport {
  return {
    id: resource.id,
    status: resource.status,
    createdAt: resource.created_at,
    completedAt: resource.completed_at,
    expiresAt: resource.expires_at,
  };
}
